module.exports = __webpack_public_path__ + "img/about_6.cfa67a47.jpg";